import { ReactNode } from "react";

import { Card, CardBody, CardProps } from "@/components/Card";
import { mergeClass } from "../utils/mergeClass";

export type RoundedCardProps = CardProps & {
  action?: ReactNode;
  bodyClassName?: string;
  compact?: boolean;
  description?: ReactNode;
  header?: ReactNode;
};

const RoundedCard = ({
  action,
  bodyClassName,
  children,
  className,
  compact = false,
  description,
  header,
  ...rest
}: RoundedCardProps) => {
  const hasHeaderContent = Boolean(header || description || action);

  return (
    <Card
      style={{ boxShadow: "0 2px 6px 0 rgba(0, 0, 0, 0.1)" }}
      className={mergeClass(
        "cle-rounded-card border bg-white rounded-3",
        compact && "cle-rounded-card--compact",
        className,
      )}
      {...rest}
    >
      {hasHeaderContent && (
        <div className="cle-rounded-card__header ">
          <div className="cle-rounded-card__header-content">
            {header && <h2 className="cle-rounded-card__title">{header}</h2>}
            {description && (
              <p className="cle-rounded-card__description">{description}</p>
            )}
          </div>
          {action && <div className="cle-rounded-card__action">{action}</div>}
        </div>
      )}
      <CardBody
        className={mergeClass("cle-rounded-card__inner", bodyClassName)}
      >
        {children}
      </CardBody>
    </Card>
  );
};

export default RoundedCard;
